import { register, CloudObject, defineProperty, defineRelation, File } from 'olympe';

/**
 * @extends {CloudObject}
 */
export class Email extends CloudObject {
    /**
     * @return {string}
     */
    getFrom() {
        return this.get(Email.fromProp);
    }

    /**
     * @return {string}
     */
    getTo() {
        return this.get(Email.toProp);
    }

    /**
     * @return {string}
     */
    getSubject() {
        return this.get(Email.subjectProp);
    }

    /**
     * @return {string}
     */
    getContent() {
        return this.get(Email.contentProp);
    }

    /**
     * @return {string}
     */
    isReceived() {
        return this.get(Email.receivedProp);
    }

    /**
     * @return {!Array<!File>}
     */
    getAttachments() {
        return /** @type {!Array<!File>} */ (this.follow(Email.attachmentsRel).executeFromCache().toArray());
    }
}

// Hardcoded tags
register('0184b3ec9fb9e915549d', Email);
Email.fromProp = defineProperty('0184b3ecff1e464986ed');
Email.toProp = defineProperty('0184b3ed229b16eda4b1');
Email.subjectProp = defineProperty('0184b3ed2c104d176472');
Email.contentProp = defineProperty('0184b3ecdba70dc4f71a');
Email.receivedProp = defineProperty('0184b3ed368de6c6e7fe');
Email.attachmentsRel = defineRelation('0184b3edcae92559b00e');
